import FW from '../fw/fw';


export default class QuickSeekManagement {

  #rmp;
  #rewindFn = null;
  #forwardFn = null;
  #fastRewindFn = null;
  #fastForwardFn = null;
  #fastTier = 0;
  #fastSeekLastCurrentTime = 0;
  #fastOffsetTime = 0;
  #fastSeekIndex = [1, 1, 1, 1];
  #fastForwardSeekingOn = false;
  #fastRewindSeekingOn = false;
  #fastRewindInterval = null;
  #fastForwardInterval = null;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  static setClassList(element, className) {
    if (element) {
      element.classList.remove(
        'rmp-i-fast-forward',
        'rmp-i-fast-fast-forward',
        'rmp-i-fast-fast-fast-forward',
        'rmp-i-fast-rewind',
        'rmp-i-fast-fast-rewind',
        'rmp-i-fast-fast-fast-rewind'
      );
      element.classList.add(className);
    }
  }

  #fastRewindIndicator(duration) {
    let timeRewind = 1000;
    switch (this.#fastTier) {
      case 1:
        break;
      case 2:
        timeRewind = 5000;
        break;
      case 3:
        timeRewind = 10000;
        break;
    }
    this.#fastSeekLastCurrentTime = this.#fastOffsetTime - (timeRewind * this.#fastSeekIndex[this.#fastTier]);
    if (this.#fastSeekLastCurrentTime <= 0) {
      this.#fastSeekLastCurrentTime = 0;
    }
    FW.setText(this.#rmp.dom.timeIndicator, FW.readableTime(this.#fastSeekLastCurrentTime / 1000));
    this.#rmp.dom.indicator.style.left = this.#fastSeekLastCurrentTime * 100 / duration + '%';
    const seekBarLeft = FW.getAbsLeft(this.#rmp.dom.seekBar);
    const indicatorLeft = FW.getAbsLeft(this.#rmp.dom.indicator);
    const indicatorWidth = FW.getPrecisionWidthWithPaddingAndBorder(this.#rmp.dom.indicator);
    const seekBarWidth = FW.getPrecisionWidthWithPaddingAndBorder(this.#rmp.dom.seekBar);
    const min = seekBarLeft + (indicatorWidth / 2);
    const max = seekBarWidth + seekBarLeft - (indicatorWidth / 2);
    if (indicatorLeft < min) {
      this.#rmp.dom.indicator.style.left = min + 'px';
    } else if (indicatorLeft > max) {
      this.#rmp.dom.indicator.style.left = max + 'px';
    }
    switch (this.#fastTier) {
      case 1:
        this.#fastSeekIndex[this.#fastTier]++;
        break;
      case 2:
        this.#fastSeekIndex[this.#fastTier]++;
        break;
      case 3:
        this.#fastSeekIndex[this.#fastTier]++;
        break;
    }
  }

  #fastForwardIndicator(duration) {
    let timeForward = 1000;
    switch (this.#fastTier) {
      case 1:
        break;
      case 2:
        timeForward = 5000;
        break;
      case 3:
        timeForward = 10000;
        break;
    }
    this.#fastSeekLastCurrentTime = this.#fastOffsetTime + (timeForward * this.#fastSeekIndex[this.#fastTier]);
    if (this.#fastSeekLastCurrentTime >= duration) {
      this.#fastSeekLastCurrentTime = duration;
    }
    FW.setText(this.#rmp.dom.timeIndicator, FW.readableTime(this.#fastSeekLastCurrentTime / 1000));
    this.#rmp.dom.indicator.style.left = this.#fastSeekLastCurrentTime * 100 / duration + '%';
    const seekBarLeft = FW.getAbsLeft(this.#rmp.dom.seekBar);
    const indicatorLeft = FW.getAbsLeft(this.#rmp.dom.indicator);
    const indicatorWidth = FW.getPrecisionWidthWithPaddingAndBorder(this.#rmp.dom.indicator);
    const seekBarWidth = FW.getPrecisionWidthWithPaddingAndBorder(this.#rmp.dom.seekBar);
    const min = seekBarLeft + (indicatorWidth / 2);
    const max = seekBarWidth + seekBarLeft - (indicatorWidth / 2);
    if (indicatorLeft < min) {
      this.#rmp.dom.indicator.style.left = min + 'px';
    } else if (indicatorLeft > max) {
      this.#rmp.dom.indicator.style.left = max + 'px';
    }
    switch (this.#fastTier) {
      case 1:
        this.#fastSeekIndex[this.#fastTier]++;
        break;
      case 2:
        this.#fastSeekIndex[this.#fastTier]++;
        break;
      case 3:
        this.#fastSeekIndex[this.#fastTier]++;
        break;
    }
  }

  #appendQuickRewind() {
    const rewindLabel = this.#rmp.labels.hint.rewind;
    let rewindValue = '5';
    if (this.#rmp.quickRewind > 7.5 && this.#rmp.quickRewind < 20) {
      rewindValue = '10';
    } else if (this.#rmp.quickRewind > 20) {
      rewindValue = '30';
    }
    if (this.#rmp.tvPlayerSkin) {
      rewindValue = 'tv';
    }
    this.#rmp.dom.quickRewind = FW.createElement(
      'button',
      'rmp-quick rmp-button rmp-i rmp-i-quick-rewind-' + rewindValue,
      null,
      null
    );
    const quickRewindLabel = rewindValue + 's ' + rewindLabel;
    this.#rmp.rmpAccessible.button(this.#rmp.dom.quickRewind,
      quickRewindLabel + ' ' + this.#rmp.labels.hint.keyboardShortcut + ' j', true, null, 'j');
    if (this.#rmp.tvPlayerSkin) {
      rewindValue = '10';
      this.#rmp.dom.fastRewind = FW.createElement(
        'button',
        'rmp-fast-rewind rmp-button rmp-i rmp-i-fast-rewind',
        null,
        null
      );
      this.#rmp.rmpAccessible.button(this.#rmp.dom.fastRewind, rewindLabel, true);
      this.#rmp.dom.controlBar.appendChild(this.#rmp.dom.fastRewind);
      this.#fastRewindFn = this.fastRewindClick.bind(this);
      this.#rmp.dom.fastRewind.addEventListener('click', this.#fastRewindFn);
    }
    this.#rmp.dom.quickRewindHint = FW.createElement(
      'div',
      'rmp-control-bar-hint rmp-color-bg',
      quickRewindLabel + ' (j)',
      this.#rmp.rtl
    );
    this.#rmp.dom.quickRewind.appendChild(this.#rmp.dom.quickRewindHint);
    this.#rewindFn = this.rewind.bind(this, parseInt(rewindValue));
    FW.addEvents(['touchend', 'click'], this.#rmp.dom.quickRewind, this.#rewindFn);
    FW.insertBefore(this.#rmp.dom.controlBar, this.#rmp.dom.quickRewind, this.#rmp.dom.volume);
  }

  #appendQuickForward() {
    const forwardLabel = this.#rmp.labels.hint.forward;
    let forwardValue = '5';
    if (this.#rmp.quickForward > 7.5 && this.#rmp.quickForward < 20) {
      forwardValue = '10';
    } else if (this.#rmp.quickForward > 20) {
      forwardValue = '30';
    }
    if (this.#rmp.tvPlayerSkin) {
      forwardValue = 'tv';
    }
    if (this.#rmp.quickRewind > 0) {
      this.#rmp.dom.quickForward = FW.createElement(
        'button',
        'rmp-quick-both rmp-button rmp-i rmp-i-quick-forward-' + forwardValue,
        null,
        null
      );
    } else {
      this.#rmp.dom.quickForward = FW.createElement(
        'button',
        'rmp-quick rmp-button rmp-i rmp-i-quick-forward-' + forwardValue,
        null,
        null
      );
    }

    const quickForwardLabel = forwardValue + 's ' + forwardLabel;
    this.#rmp.rmpAccessible.button(this.#rmp.dom.quickForward,
      quickForwardLabel + ' ' + this.#rmp.labels.hint.keyboardShortcut + ' l', true, null, 'l');
    if (this.#rmp.tvPlayerSkin) {
      forwardValue = '10';
      this.#rmp.dom.fastForward = FW.createElement(
        'button',
        'rmp-fast-forward rmp-button rmp-i rmp-i-fast-forward',
        null,
        null
      );
      this.#rmp.rmpAccessible.button(this.#rmp.dom.fastForward, forwardLabel, true);
      this.#rmp.dom.controlBar.appendChild(this.#rmp.dom.fastForward);
      this.#fastForwardFn = this.fastForwardClick.bind(this);
      this.#rmp.dom.fastForward.addEventListener('click', this.#fastForwardFn);
    }
    this.#rmp.dom.quickForwardHint = FW.createElement(
      'div',
      'rmp-control-bar-hint rmp-color-bg',
      quickForwardLabel + ' (l)',
      this.#rmp.rtl
    );
    this.#rmp.dom.quickForward.appendChild(this.#rmp.dom.quickForwardHint);
    this.#forwardFn = this.forward.bind(this, parseInt(forwardValue));
    FW.addEvents(['touchend', 'click'], this.#rmp.dom.quickForward, this.#forwardFn);
    FW.insertBefore(this.#rmp.dom.controlBar, this.#rmp.dom.quickForward, this.#rmp.dom.volume);
  }

  #resetQuickSeek() {
    this.#fastForwardSeekingOn = false;
    this.#fastRewindSeekingOn = false;
    window.clearInterval(this.#fastForwardInterval);
    window.clearInterval(this.#fastRewindInterval);
    this.#rmp.dom.indicator.style.display = 'none';
    const currentTime = this.#rmp.currentTime;
    if (currentTime !== this.#fastSeekLastCurrentTime) {
      this.#rmp.seekTo(this.#fastSeekLastCurrentTime).catch(error => {
        this.#rmp.rmpUtils.warning(1016, error);
      });
    }
    this.#fastTier = 0;
    this.#fastSeekIndex = [1, 1, 1, 1];
    this.#fastSeekLastCurrentTime = 0;
    QuickSeekManagement.setClassList(this.#rmp.dom.fastIndicator, 'rmp-i-fast-forward');
  }

  rewind(range, event) {
    FW.eventStopPrevent(event);
    if (this.#rmp.tvPlayerSkin && (this.#fastForwardSeekingOn || this.#fastRewindSeekingOn)) {
      this.#rmp.play().catch(error => {
        this.#rmp.rmpUtils.warning(1014, error);
      });
      return;
    }
    if (typeof range === 'number' && range > 0) {
      const currentTime = this.#rmp.currentTime;
      const msRange = range * 1000;
      if (currentTime > msRange) {
        const seekValueMs = currentTime - msRange;
        if (this.#rmp.isDvr) {
          this.#rmp.dvrSeekTo(seekValueMs).catch(error => {
            this.#rmp.rmpUtils.warning(1018, error);
          });
        } else {
          this.#rmp.seekTo(seekValueMs).catch(error => {
            this.#rmp.rmpUtils.warning(1016, error);
          });
        }
      }
    }
  }

  fastRewindClick(event) {
    FW.eventStopPrevent(event);
    if (this.#fastForwardSeekingOn) {
      this.#rmp.play().catch(error => {
        this.#rmp.rmpUtils.warning(1014, error);
      });
      return;
    }
    if (!this.#fastRewindSeekingOn) {
      this.#rmp.dom.video.addEventListener('play', () => {
        this.#resetQuickSeek();
      }, { once: true });
    }
    this.#fastRewindSeekingOn = true;
    this.#rmp.pause();
    window.clearInterval(this.#fastRewindInterval);
    this.#rmp.dom.indicator.style.display = 'block';
    const currentTime = this.#rmp.currentTime;
    const duration = this.#rmp.duration;
    this.#fastTier++;
    if (this.#fastTier > 3) {
      this.#fastTier = 1;
    }
    this.#fastSeekIndex = [1, 1, 1, 1];
    switch (this.#fastTier) {
      case 1:
        this.#fastOffsetTime = this.#fastSeekLastCurrentTime || currentTime;
        QuickSeekManagement.setClassList(this.#rmp.dom.fastIndicator, 'rmp-i-fast-rewind');
        this.#fastRewindIndicator(duration);
        this.#fastRewindInterval = window.setInterval(() => {
          this.#fastRewindIndicator(duration);
        }, 50);
        break;
      case 2:
        this.#fastOffsetTime = this.#fastSeekLastCurrentTime;
        QuickSeekManagement.setClassList(this.#rmp.dom.fastIndicator, 'rmp-i-fast-fast-rewind');
        this.#fastRewindIndicator(duration);
        this.#fastRewindInterval = window.setInterval(() => {
          this.#fastRewindIndicator(duration);
        }, 50);
        break;
      case 3:
        this.#fastOffsetTime = this.#fastSeekLastCurrentTime;
        QuickSeekManagement.setClassList(this.#rmp.dom.fastIndicator, 'rmp-i-fast-fast-fast-rewind');
        this.#fastRewindIndicator(duration);
        this.#fastRewindInterval = window.setInterval(() => {
          this.#fastRewindIndicator(duration);
        }, 50);
        break;
    }
  }

  forward(range, event) {
    FW.eventStopPrevent(event);
    if (this.#rmp.tvPlayerSkin && (this.#fastForwardSeekingOn || this.#fastRewindSeekingOn)) {
      this.#rmp.play().catch(error => {
        this.#rmp.rmpUtils.warning(1014, error);
      });
      return;
    }
    if (typeof range === 'number' && range > 0) {
      const currentTime = this.#rmp.currentTime;
      const msRange = range * 1000;
      if (this.#rmp.isDvr && this.#rmp.isDvrLiveMode) {
        return;
      }
      const seekValueMs = currentTime + msRange;
      if (this.#rmp.isDvr) {
        if (!this.#rmp.isDvrLiveMode) {
          this.#rmp.dvrSeekTo(seekValueMs).catch(error => {
            this.#rmp.rmpUtils.warning(1018, error);
          });
        }
      } else {
        this.#rmp.seekTo(seekValueMs).catch(error => {
          this.#rmp.rmpUtils.warning(1016, error);
        });
      }
    }
  }

  fastForwardClick(event) {
    FW.eventStopPrevent(event);
    if (this.#fastRewindSeekingOn) {
      this.#rmp.play().catch(error => {
        this.#rmp.rmpUtils.warning(1014, error);
      });
      return;
    }
    if (!this.#fastForwardSeekingOn) {
      this.#rmp.dom.video.addEventListener('play', () => {
        this.#resetQuickSeek();
      }, { once: true });
    }
    this.#fastForwardSeekingOn = true;
    this.#rmp.pause();
    window.clearInterval(this.#fastForwardInterval);
    this.#rmp.dom.indicator.style.display = 'block';
    const currentTime = this.#rmp.currentTime;
    const duration = this.#rmp.duration;
    this.#fastTier++;
    if (this.#fastTier > 3) {
      this.#fastTier = 1;
    }
    this.#fastSeekIndex = [1, 1, 1, 1];
    switch (this.#fastTier) {
      case 1:
        this.#fastOffsetTime = this.#fastSeekLastCurrentTime || currentTime;
        QuickSeekManagement.setClassList(this.#rmp.dom.fastIndicator, 'rmp-i-fast-forward');
        this.#fastForwardIndicator(duration);
        this.#fastForwardInterval = window.setInterval(() => {
          this.#fastForwardIndicator(duration);
        }, 50);
        break;
      case 2:
        this.#fastOffsetTime = this.#fastSeekLastCurrentTime;
        QuickSeekManagement.setClassList(this.#rmp.dom.fastIndicator, 'rmp-i-fast-fast-forward');
        this.#fastForwardIndicator(duration);
        this.#fastForwardInterval = window.setInterval(() => {
          this.#fastForwardIndicator(duration);
        }, 50);
        break;
      case 3:
        this.#fastOffsetTime = this.#fastSeekLastCurrentTime;
        QuickSeekManagement.setClassList(this.#rmp.dom.fastIndicator, 'rmp-i-fast-fast-fast-forward');
        this.#fastForwardIndicator(duration);
        this.#fastForwardInterval = window.setInterval(() => {
          this.#fastForwardIndicator(duration);
        }, 50);
        break;
    }
  }

  init() {
    if (this.#rmp.quickRewind > 0) {
      this.#appendQuickRewind();
    }
    if (this.#rmp.quickForward > 0) {
      this.#appendQuickForward();
    }
    if (this.#rmp.tvPlayerSkin) {
      this.#rmp.dom.fastIndicator = FW.createElement(
        'span',
        'rmp-fast-indicator rmp-i rmp-i-fast-forward',
        null,
        null
      );
      FW.insertBefore(this.#rmp.dom.indicator, this.#rmp.dom.fastIndicator, this.#rmp.dom.timeIndicator);
    }
  }

}
